import { type ComponentPropsWithoutRef, useId } from "react";
import { twMerge } from "tailwind-merge";

import { Label } from "./Label";
import { Description } from "./Description";
import { getInputFieldClasses } from "../../utils/getInputFieldClasses";
import { ErrorMessage, type ErrorKey } from "./ErrorMessage";

type Size = "sm" | "md" | "lg";

interface TextareaProps extends ComponentPropsWithoutRef<"textarea"> {
  label: string;
  description?: string;
  error?: ErrorKey;
  size?: Size;
}

export const Textarea = ({
  label,
  description,
  error,
  id,
  required,
  size = "md",
  ...textareaProps
}: TextareaProps) => {
  const generatedId = useId();
  const textareaId = id ?? generatedId;

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={textareaId} label={label} required={required} />

      <textarea
        {...textareaProps}
        id={textareaId}
        required={required}
        aria-invalid={error ? true : undefined}
        className={twMerge(
          getInputFieldClasses(size, !!error),
          "min-h-36 resize-none"
        )}
      />

      {error && <ErrorMessage error={error} />}
      {description && !error && <Description description={description} />}
    </div>
  );
};
